module.exports = __webpack_public_path__ + "img/stars.b878eee9.svg";